const { calculateEtldPlusOne } = require('../gtm/utils');
/**
 * @returns a value based on TLD or undefined
 * supported values: "de" | "at" | "be" | "it" | "hu" | "es" | "fr" | "lu" | "nl" | "bg" | "cz" | "ro" | "int" | "pl" | "hr" | "ru" | "se" | "tr" | "ua" | "gb" | "at_ca" | "ah_ca" | "at_nl" | "gw_at"
 */

const MarketValues = [
    'de',
    'at',
    'be',
    'it',
    'hu',
    'es',
    'fr',
    'lu',
    'nl',
    'bg',
    'cz',
    'ro',
    'hu',
    'int',
    'pl',
    'hr',
    'ru',
    'se',
    'tr',
    'ua',
    'at_ca',
    'ah_ca',
    'at_nl',
    'gw_at',
];

const isGA4Market = (input) => MarketValues.some((value) => value === input);
const MARKET_BY_ETLD_PLUS_ONE = {
    'autotrader.nl': 'at_nl',
    'gebrauchtwagen.at': 'gw_at',
    'autotrader.ca': 'at_ca',
    'autohebdo.net': 'ah_ca',
};
const ga4Market = () => {
    try {
        const tld = window.location.hostname.split('.').pop();
        const etldPlusOne = calculateEtldPlusOne(window.location.hostname);
        const ga4MarketValue = tld === 'com' ? 'int' : tld;
        const market = MARKET_BY_ETLD_PLUS_ONE[etldPlusOne] || ga4MarketValue;
        return isGA4Market(market) ? market : undefined;
    } catch (e) {
        return undefined;
    }
};

module.exports = {
    ga4Market: ga4Market,
};



// WEBPACK FOOTER //
// ./src/ga4/market.js